import {
  useReactMutation,
  getPostServicePromiseDeprecated,
  useTranslation,
  useReactQueryClient,
  ApiConstants
} from '@invision/core';
import type {
  SecurityRestoreSessionRequest,
  SecurityRestoreSessionResponse
} from 'invApi';
import { RETRIEVE_SESSION_MUTATION_KEY } from './useRetrieveSessionMutation';

export function useRestoreSessionMutation() {
  const { t } = useTranslation();
  const queryClient = useReactQueryClient();

  return useReactMutation<
    SecurityRestoreSessionResponse,
    { request: SecurityRestoreSessionRequest; systemId?: string }
  >(
    ['restoreSession'],
    ({ request, systemId }) => {
      return getPostServicePromiseDeprecated(
        {
          path: 'Security/RestoreSession',
          headers: systemId
            ? {
                [ApiConstants.SYSTEM_ID_HEADER]: systemId
              }
            : {}
        },
        request
      );
    },
    {
      onSuccess: (response: SecurityRestoreSessionResponse) => {
        queryClient.setQueryData([RETRIEVE_SESSION_MUTATION_KEY], response);
        queryClient.invalidateQueries([RETRIEVE_SESSION_MUTATION_KEY]);
      }
    },
    {
      useLoadingIndicator: true,
      errorMessage: (error: string) => {
        if (error === '404') {
          return t('Invalid or expired session token');
        }
        return '';
      }
    }
  );
}
